var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("rect", {
    id: "Iconly/Regular/Light/Paper Negative",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#fff",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M8.08 2.76C6 2.75 4.29 4.41 4.25 6.49L4.25 17.33C4.21 19.38 5.84 21.08 7.89 21.11C7.96 21.11 8.02 21.11 8.08 21.11L16.07 21.11C18.14 21.09 19.8 19.4 19.8 17.33L19.8 8.04L14.73 2.76L8.08 2.76Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M14.47 2.75L14.47 5.65C14.47 7.07 15.62 8.23 17.04 8.23L19.79 8.23",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M14.29 13.74L9.39 13.74",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clearIcon.c0baeeccd7d16332c3e364217000cc66.svg";
export { ForwardRef as ReactComponent };